<template>
    <v-container fluid class="px-8">
        <v-row justify="center">
            <v-col cols="12" md="10">
                <div class="card-box text-center">
                    <v-icon size="72" color="#54667a">mdi-link-off</v-icon>
                    <h1 class="page-title color-grey-onfly">404</h1>
                    <h2 class="page-title color-grey-onfly">Link inválido ou expirado</h2>
                    <p class="color-grey-onfly">
                        Não encontramos uma reserva associada a este link.
                        Verifique se o link está correto ou entre em contato com o suporte.
                    </p>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "ReserveNotFound",
}
</script>

<style lang="scss" scoped>
.color-grey-onfly {
    color: #54667a !important;
}
.page-title {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 24px;
}
.card-box {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    padding: 48px 32px;
    border: 1px solid lightgrey;
    margin-top: 48px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}
</style>
